import { render, staticRenderFns } from "./OfferToTeamMembersList.vue?vue&type=template&id=c6a851c2&"
import script from "./OfferToTeamMembersList.vue?vue&type=script&lang=js&"
export * from "./OfferToTeamMembersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6a851c2')) {
      api.createRecord('c6a851c2', component.options)
    } else {
      api.reload('c6a851c2', component.options)
    }
    module.hot.accept("./OfferToTeamMembersList.vue?vue&type=template&id=c6a851c2&", function () {
      api.rerender('c6a851c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/OfferToTeamMembers/OfferToTeamMembersList.vue"
export default component.exports